export enum CostMapStepEnum {
  TEMPLATES = "templates",
  ITEMS = "items",
  SUMMARY = "summary",
}
